import { z } from 'zod/v4'

export const userAdditionalInfoValidation = () => {
  return z.object({
    country_id: z.string({ message: 'Country is required' }).min(1, { message: 'Country is required' }),
    province_id: z.string().optional().nullable().or(z.literal('')),
    city_id: z.string().optional().nullable().or(z.literal('')),
    address_line: z.string().min(1, { message: 'Address line is required' }),
    subdistrict: z.string().optional().nullable().or(z.literal('')),
    zip_code: z.string().optional().nullable().or(z.literal('')),
    withdraw_provider: z.string().optional().nullable().or(z.literal('')),
    withdraw_account_name: z.string().optional().nullable().or(z.literal('')),
    withdraw_account_number: z.string().optional().nullable().or(z.literal('')),
    withdraw_swift_code: z.string().optional().nullable().or(z.literal('')),
  })
}